<template>
    <div id="container" v-show="showVideo">
        <audio controls autoplay id="html5video">
            <source src="" :type="type">
        </audio>

        <button id="closeVideo" v-on:click="destroy">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                 id="Capa_1" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;"
                 xml:space="preserve" width="30px" height="30px" class=""><g>
                <circle cx="25" cy="25" r="25" data-original="#D75A4A" class="active-path" data-old_color="#353232" fill="#363333"/>
                <polyline style="stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;" points="16,34 25,25 34,16   " stroke="#ffffff" fill="#ffffff"/>
                <polyline style="stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;" points="16,16 25,25 34,34   " stroke="#ffffff" fill="#ffffff"/></g>
            </svg>
        </button>
        <div class="popup_bg" v-on:click="destroy"></div>
    </div>
</template>

<script>

    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';

    export default {
        name: "AudioPlayer",
        mixins:[common,storeMapper],
        data() {
            return {
                url: "",
                type: "",
                showVideo: false
            }
        },
        methods: {
            show(type, url)
            {

                jQuery("#html5video").attr("src", url);
                this.type = type;
                this.showVideo = true;

                var video = document.getElementById('html5video');
                if (!this.checkIsMobile()) {
                    video.load();
                    video.play();
                }


            },
            destroy()
            {

                jQuery("#html5video").attr("src", "");

                this.type = "";
                this.showVideo = false;
                var video = document.getElementById('html5video');
                video.pause();


            }
        },
    }
</script>

<style scoped>
    #container {
        width: 100%;
        height: 100%;
        top:0;
        left: 0;
        position: fixed;
        z-index: 9998;
        background: rgba(0,0,0, 0.5);
    }

    .popup_bg {
        width: 100%;
        height: 100%;
        top:0;
        left: 0;
        position: fixed;
        z-index: 9999;
        background: rgba(0,0,0, 0.5);
    }

    #closeVideo {
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 100000;
    }

    #html5video {
        position: absolute;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        max-height: 100%;
        max-width: 100%;
        margin: auto;
        z-index: 100000;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/player/AudioPlayer.vue